<template>
  <div class=" container mt-4">
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormClientedatofiscal" role="form" method="post" autocomplete="off" onSubmit="return false">
					
					<div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                            <label class="form-label" for="Nombre">Nombre</label>
                            <input type="text" v-model="objClienteDireccion.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
                            <CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
                        </div>

                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                            <label class="form-label" for="TipoDireccion">Tipo Direccion</label>
                            <br>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="Casa" v-model="objClienteDireccion.TipoDireccion">
                                <label class="form-check-label" for="inlineRadio1"><i class="fal fa-house fa-lg"></i> Casa</label>
                            </div>
                            
                    
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="Trabajo" v-model="objClienteDireccion.TipoDireccion">
                                <label class="form-check-label" for="inlineRadio2"><i class="fal fa-suitcase fa-lg"></i> Trabajo</label>
                            </div>

                            <CValidation v-if="this.errorvalidacion.TipoDireccion" :Mensaje="'*'+errorvalidacion.TipoDireccion[0]"/>
                        </div>

                    </div>
                    
                    <div class="form-group row mt-2">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label class="form-label" for="Calle">Calle</label>
                            <input type="text" v-model="objClienteDireccion.Calle" class="form-control" id="Calle" placeholder="Ingresar Calle" />
                            <CValidation v-if="this.errorvalidacion.Calle" :Mensaje="'*'+errorvalidacion.Calle[0]"/>
                        </div>

                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label class="form-label" for="NoExt">No Ext</label>
                            <input type="text" v-model="objClienteDireccion.NoExt" class="form-control" id="NoExt" placeholder="Ingresar NoExt" />
                            <CValidation v-if="this.errorvalidacion.NoExt" :Mensaje="'*'+errorvalidacion.NoExt[0]"/>
                        </div>

                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label class="form-label" for="NoInt">No Int</label>
                            <input type="text" v-model="objClienteDireccion.NoInt" class="form-control" id="NoInt" placeholder="Ingresar NoInt" />
                            <CValidation v-if="this.errorvalidacion.NoInt" :Mensaje="'*'+errorvalidacion.NoInt[0]"/>
                        </div>
                    </div>
                    
                    
                    <div class="form-group row mt-2">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                            <label class="form-label" for="Cruzamiento1">Cruzamiento 1</label>
                            <input type="text" v-model="objClienteDireccion.Cruzamiento1" class="form-control" id="Cruzamiento1" placeholder="Ingresar Cruzamiento1" />
                            <CValidation v-if="this.errorvalidacion.Cruzamiento1" :Mensaje="'*'+errorvalidacion.Cruzamiento1[0]"/>
                        </div>

                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                            <label class="form-label" for="Cruzamiento2">Cruzamiento 2</label>
                            <input type="text" v-model="objClienteDireccion.Cruzamiento2" class="form-control" id="Cruzamiento2" placeholder="Ingresar Cruzamiento2" />
                            <CValidation v-if="this.errorvalidacion.Cruzamiento2" :Mensaje="'*'+errorvalidacion.Cruzamiento2[0]"/>
                        </div>
                    </div>
                    
                    
                    <div class="form-group row mt-2">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label class="form-label" for="Colonia">Colonia</label>
                            <input type="text" v-model="objClienteDireccion.Colonia" class="form-control" id="Colonia" placeholder="Ingresar Colonia" />
                            <CValidation v-if="this.errorvalidacion.Colonia" :Mensaje="'*'+errorvalidacion.Colonia[0]"/>
                        </div>

                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label class="form-label" for="CodigoPostal">CodigoPostal</label>
                            <input type="text" v-model="objClienteDireccion.CodigoPostal" class="form-control" id="CodigoPostal" placeholder="Ingresar CodigoPostal" />
                            <CValidation v-if="this.errorvalidacion.CodigoPostal" :Mensaje="'*'+errorvalidacion.CodigoPostal[0]"/>
                        </div>

                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label class="form-label" for="Municipio">Municipio</label>
                            <input type="text" v-model="objClienteDireccion.Municipio" class="form-control" id="Municipio" placeholder="Ingresar Municipio" />
                            <CValidation v-if="this.errorvalidacion.Municipio" :Mensaje="'*'+errorvalidacion.Municipio[0]"/>
                        </div>
                    </div>
                    
                
                    
                    <div class="form-group row mt-2">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                            <label class="form-label" for="Estado">Estado</label>
                            <input type="text" v-model="objClienteDireccion.Estado" class="form-control" id="Estado" placeholder="Ingresar Estado" />
                            <CValidation v-if="this.errorvalidacion.Estado" :Mensaje="'*'+errorvalidacion.Estado[0]"/>
                        </div>

                        <!--<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label class="form-label" for="Pais">Pais</label>
                            <input type="text" v-model="objClienteDireccion.Pais" class="form-control" id="Pais" placeholder="Ingresar Pais" />
                            <CValidation v-if="this.errorvalidacion.Pais" :Mensaje="'*'+errorvalidacion.Pais[0]"/>
                        </div>-->

                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                            <label class="form-label" for="Telefono">Telefono</label>
                            <input type="text" v-model="objClienteDireccion.Telefono" class="form-control" id="Telefono" placeholder="Ingresar Telefono" />
                            <CValidation v-if="this.errorvalidacion.Telefono" :Mensaje="'*'+errorvalidacion.Telefono[0]"/>
                        </div>
                    </div>
                    
                    
                    <div class="form-group row mt-2">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <label class="form-label" for="Referencias">Referencias</label>
                            <textarea v-model="objClienteDireccion.Referencias" class="form-control" rows="3" id="Referencias" placeholder="Ingresar Referencias" />
                            <CValidation v-if="this.errorvalidacion.Referencias" :Mensaje="'*'+errorvalidacion.Referencias[0]"/>
                        </div>
                    </div>
					
					<br>
				</form>
			</div>
		</template>
	</CLoader>
  </div>
</template>

<script>
import CLoader from "@/components/CLoader.vue";
import StaticComboBox from "@/helpers/StaticComboBox";

export default {
    name: 'DatosFiscales',
    props:['poBtnSave'],
    components:{
        CLoader,
    },

    data() {
        return {
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad:  true,
            },

            objMzipCliente: {	
                IdCliente: 0,
                IdClienteMicrosip: 0,
                IdPaqueteria: 0,
                //paqueteria: {IdPaqueteria: 1, Nombre: "DHL"}
            },

            objClienteDireccion: {
                IdClienteDireccion: 0,
				IdCliente: '',
				TipoDireccion: '',
				Nombre: '',
				Calle: '',
				NoExt: '',
				NoInt: '',
				Cruzamiento1: '',
				Cruzamiento2: '',
				Colonia: '',
				CodigoPostal: '',
				Estado: '',
				Municipio: '',
				Pais: '',
				Telefono: '',
				Referencias: '',
				RfcCliente: '',
            },

            ListaCombo1: StaticComboBox.RegimenesFiscales,
            errorvalidacion:[],
            Emit: this.poBtnSave.EmitSeccion,
        };
    },

    created() {

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$off('Save_'+this.Emit);

         this.bus.$on('Recovery_'+this.Emit,(Obj)=>{
            // console.log(Obj);
            this.ConfigLoad.ShowLoader=true;
            this.Limpiar();

            this.objMzipCliente = Obj;
           
            if (this.objMzipCliente.IdCliente>0) {
                this.recoveryInformacion();
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }

            this.bus.$on('Save_'+this.Emit,()=>{
                this.Guardar();
            });
            
        });

    },

    mounted() {
        
    },

    methods: {

        Limpiar() {
            this. objClienteDireccion = {
                IdClienteDireccion: 0,
				IdCliente: '',
				TipoDireccion: '',
				Nombre: '',
				Calle: '',
				NoExt: '',
				NoInt: '',
				Cruzamiento1: '',
				Cruzamiento2: '',
				Colonia: '',
				CodigoPostal: '',
				Estado: '',
				Municipio: '',
				Pais: '',
				Telefono: '',
				Referencias: '',
				RfcCliente: '',
            };
        },

        async recoveryInformacion() {
            await this.$http.get("clientesdirecciones/"+this.objMzipCliente.IdCliente)
            .then((res) => {

                if(res.data.status !== false){
                    this.objClienteDireccion = res.data.data;
                }

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },

        async Guardar()
        {
			this.errorvalidacion = [];
			this.poBtnSave.Toast = 0; 
			this.poBtnSave.DisableBtn = true;

			if(this.objClienteDireccion.IdClienteDireccion == 0) {
                this.objClienteDireccion.IdCliente = this.objMzipCliente.IdCliente;
				await this.$http.post(
					'clientesdirecciones',this.objClienteDireccion
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'clientesdirecciones/'+this.objClienteDireccion.IdClienteDireccion,
					this.objClienteDireccion
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {   
            
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
    },
};
</script>